module.exports = __webpack_public_path__ + "img/top-service-1.95b64029.svg";